export function isCardsBingoGame(gameType) {
    return [
        'BingoMex', 'BingoAnimals', 'BingoCartoon',
        'Movies', 'MoviesKids', 'Football', 'Halloween',
        'Superheroes', 'Cartoon', 'XMas'
    ].includes(gameType);
}
export function reload() {
    window.location.reload();
}
